<template>
    <div>
        <p class="text-center font-weight-black indigo--text ma-5">Atsumaritai</p>
        <div id="firebaseui-auth-container"></div>
    </div>
</template>

<script>
import * as firebaseui from 'firebaseui-ja';
import * as firebase from "firebase/app";
import "firebase/auth";
// import { auth } from '../plugins/firebase';
import "firebaseui-ja/dist/firebaseui.css";

// FirebaseUI config.
var uiConfig = {
    signInSuccessUrl: '/',
    signInOptions: [
        {
            // Leave the lines as is for the providers you want to offer your users.
            provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            // firebase.auth.GithubAuthProvider.PROVIDER_ID,
            // firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            // firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
        },{
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
            requireDisplayName: false
        },{
            provider: firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        },
    ],
    // tosUrl and privacyPolicyUrl accept either url string or a callback
    // function.
    // Terms of service url/callback.
    tosUrl: '/#/termsofservice',
    // Privacy policy url/callback.
    privacyPolicyUrl: '/#/privatepolicy'
};

export default {
    data: () => ({
    }),
    mounted: function() {
        let ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth())
        ui.start('#firebaseui-auth-container', uiConfig);
        // if (ui.isPendingRedirect()) {
        //     ui.start('#firebaseui-auth-container', uiConfig);
        // }
    }
}
</script>
